'use client';

import { useClientTranslation } from '@/hook/translate';
import { Noto_Serif } from 'next/font/google';
import clsx from 'clsx';

const notoSerif = Noto_Serif({ subsets: ['latin'] });

interface IProps {
  title: string;
  img: string;
  intro: string;
  author: string;
  authorIntro: string;
  insight: string[]
}

export default function MobileBookInfo(props: IProps) {
  const { t } = useClientTranslation();
  return (
    <div className='mobile-book-info pt-10 pb-10'>
      <div className="mobile-why-listen">
        <h2 className={ clsx( 'text-left text-22-30 font-extrabold') }>
        <span >{ t('whyListenTo', 'mindfulAudio') } { props.title }</span>
        </h2>
        <p className={ clsx(' text-16-28 pt-4', notoSerif.className) }>{ props.intro }</p>
      </div>
      <div className="mobile-insight pt-10">
        <h2 className='text-left text-22-30 font-extrabold'>{ t('keyInsight', 'mindfulAudio') } { props.title }</h2>
        <ul className='key-list list-decimal pl-[20px] pt-4'>
          {
            props.insight?.map(item => {
              return (
                <li className={ clsx(' text-16-22 pb-4', notoSerif.className) } key={item}>{ item }</li>
              );
            })
          }
        </ul>
      </div>
      <div className="mobile-author-info pt-10">
        <h2 className='text-left text-22-30 font-extrabold'>{ t('author') } : { props.author }</h2>
        <p className={ clsx('text-16-28 pt-4', notoSerif.className) }>{ props.authorIntro }</p>
      </div>
    </div>
  );
}
